import { boot } from "quasar/wrappers";

import FtxDialog from "components/common/dialog/ftx-dialog";
import SvgIcon from "components/SvgIcon";
import AppIcon from "components/common/AppIcon";

export default boot(async ({ app }) => {
  app.component("FtxDialog", FtxDialog);
  app.component("SvgIcon", SvgIcon);
  app.component("AppIcon", AppIcon);
});
